/*
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-09-21 15:57:15
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2022-11-10 10:16:17
 * @FilePath: \frontend-user\src\store\modules\contactDetails.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import appStore from '@/store'
import { openreplaySetMetadata, openreplaySetUserID } from 'utils/openreplay'

// Deep copy a copy of data
// 深度 copy 一份数据
const cloneDeep = (data) => {
  return JSON.parse(JSON.stringify(data))
}

const initContactDetailsState = {
  user: {
    id: '',
    name: '',
    email: '',
    phone: ''
  },

  deliveryInfo: {}
}
const module_ = {
  state: cloneDeep(initContactDetailsState),
  mutations: {
    // Initialize state
    // 初始化 state
    resetContactDetailsState(state) {
      for (var i in initContactDetailsState) {
        state[i] = initContactDetailsState[i]
      }
    },
    // Add attributes under the user object
    // 添加 user 对象下的属性
    addUserProp(state, {
      prop,
      val
    }) {
      state.user[prop] = val
      // Set related configurations of openreplay
      // 设置 openreplay 的相关配置
      if (prop === 'email') {
        openreplaySetUserID(val)
      } else {
        openreplaySetMetadata(prop, val)
      }
    },

    addDeliveryInfo(state, deliveryInfo) {
      const venueId = appStore.state.venueId
      // 必须走 `Vue.set`：`deliveryInfo` 在模块注册那一刻就被 observe 了，此后往它身上
      // **直接加 `venueId` 这个新键**建不出 getter/setter —— 这一格对模板永久是死的。
      //
      // 触发条件只是「顾客第一次在这家店填配送地址」，不需要任何历史数据、也不需要改版：
      // 初值就是 `deliveryInfo: {}`（见 `initContactDetailsState`），所以第一次写进来的
      // venue 必然是新键。之后无论改几次地址、换几次 orderType，都不会再有通知源。
      //
      // 消费方是钱和地址两条：`store/getters.js:180-182` 用它算**配送费并计入总价**，
      // `components/DeliveryInfoDialog/index.vue:396/:860` 用它回显。总价那条是每次重算的
      // method-style getter，所以钱是对的 —— 错的是屏幕会停在旧的配送费/旧地址上。
      //
      // 原先第一句 `if (!...) state.deliveryInfo[venueId] = {}` 是死代码：下一句无条件覆盖它，
      // 而且它自己就是「直接加新键」，正是造成上面那个死格子的那一句。一并删掉。
      Vue.set(state.deliveryInfo, venueId, deliveryInfo)
    }
  },
  actions: {},
  getters: {}
}

export default module_